import script from "./invoice-enterprise-dialog-address.vue?vue&type=script&lang=tsx&name=invoice-enterprise-dialog-address&setup=true"
export * from "./invoice-enterprise-dialog-address.vue?vue&type=script&lang=tsx&name=invoice-enterprise-dialog-address&setup=true"

const __exports__ = script;

export default __exports__